module.exports = __webpack_public_path__ + "static/img/happiness.d415fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/happiness.png
// module id = pya/
// module chunks = 0